import React from "react";
import { Container, ContainerButton, GoBack, LogoVM } from "./styles";
import history from "../../services/history";

export default function NewLogoSVG({ backButton = false, withoutLogo = false }) {
	const goBack = () => {
		history.goBack();
	};

	return (
		<Container withoutLogo={withoutLogo}>
			{backButton ? (
				<ContainerButton>
					<GoBack onClick={goBack}>
						<span>voltar</span>
					</GoBack>
				</ContainerButton>
			) : null}
			<LogoVM></LogoVM>
		</Container>
	);
}
